import InstitutionalInformationRepository from '@/domain/repositories/InstitutionalInformationRepository';
import InstitutionalInformationDataStore from '../datastores/InstitutionalInformationDataStore';
import InstitutionalInformationDataStoreFactory from '../factories/InstitutionalInformationDataStoreFactory';

export default class InstitutionalInformationDataRepository
  implements InstitutionalInformationRepository
{
  getInstitutionalInformation(campus: string, career: string, zona: string) {
    const institutionalInformationDataStore: InstitutionalInformationDataStore =
      InstitutionalInformationDataStoreFactory.create();
    return institutionalInformationDataStore.getInstitutionalInformation(
      campus,
      career,
      zona
    );
  }
}
